<template>
  <div class="dish-showcase">
    <!-- 侧边菜单 -->
    <div class="sidebar">
      <div class="sidebar-title">菜品分类</div>
      <ul class="category-list">
        <li><router-link to="/cp/mycp1">荤菜</router-link></li>
        <li><router-link to="/cp/mycp5" exact-active-class="active">半荤菜</router-link></li>
        <li><router-link to="/cp/mycp2">素菜</router-link></li>
        <li><router-link to="/cp/mycp3">主食甜点</router-link></li>
        <li><router-link to="/cp/mycp4">精品小吃</router-link></li>
      </ul>
    </div>

    <!-- 菜品网格区域 -->
    <div class="dish-grid">
      <div class="dish-card" v-for="(dish, idx) in dishList" :key="idx">
        <el-image
          class="dish-img"
          :src="dish.thumb"
          :preview-src-list="[dish.preview]"
          fit="cover"
        >
          <div slot="error" class="error-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <div class="dish-info">
          <span class="dish-name">{{ dish.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dishList: [
        { name: '白菜烩鸡丸', thumb: require('../../assets/cp/jbc/bhc/01.jpg'), preview: require('../../assets/cp/jbc/bhc/01-big.jpg') },
        { name: '菠菜根烧丸子', thumb: require('../../assets/cp/jbc/bhc/03.jpg'), preview: require('../../assets/cp/jbc/bhc/03-b.jpg') },
        { name: '茶树菇焖鸡', thumb: require('../../assets/cp/jbc/bhc/04.jpg'), preview: require('../../assets/cp/jbc/bhc/04-b.jpg') },
        { name: '大烩菜', thumb: require('../../assets/cp/jbc/bhc/05.jpg'), preview: require('../../assets/cp/jbc/bhc/05-b.jpg') },
        { name: '粉皮炖羊杂', thumb: require('../../assets/cp/jbc/bhc/06.jpg'), preview: require('../../assets/cp/jbc/bhc/06-b.jpg') },
        { name: '粉皮炖猪肉', thumb: require('../../assets/cp/jbc/bhc/07.jpg'), preview: require('../../assets/cp/jbc/bhc/07-b.jpg') },
        { name: '粉皮焖鸡', thumb: require('../../assets/cp/jbc/bhc/08.jpg'), preview: require('../../assets/cp/jbc/bhc/08-b.jpg') },
        { name: '黄豆芽炖酥肉', thumb: require('../../assets/cp/jbc/bhc/09.jpg'), preview: require('../../assets/cp/jbc/bhc/09-b.jpg') },
        { name: '萝卜干炒腊肉', thumb: require('../../assets/cp/jbc/bhc/10.jpg'), preview: require('../../assets/cp/jbc/bhc/10-b.jpg') },
        { name: '五花肉炖菜', thumb: require('../../assets/cp/jbc/bhc/14.jpg'), preview: require('../../assets/cp/jbc/bhc/14-b.jpg') },
        { name: '香菇蒸滑鸡', thumb: require('../../assets/cp/jbc/bhc/15.jpg'), preview: require('../../assets/cp/jbc/bhc/15-b.jpg') },
        { name: '腰果虾仁', thumb: require('../../assets/cp/jbc/bhc/16.jpg'), preview: require('../../assets/cp/jbc/bhc/16-b.jpg') },
        { name: '虾仁鸡汁萝卜', thumb: require('../../assets/cp/jbc/sc/14.jpg'), preview: require('../../assets/cp/jbc/sc/14-b.jpg') },
        { name: '蒜苗炒鸡蛋', thumb: require('../../assets/cp/jbc/sc/21.jpg'), preview: require('../../assets/cp/jbc/sc/21-b.jpg') },
        { name: '番茄鸡蛋', thumb: require('../../assets/cp/jbc/sc/07.jpg'), preview: require('../../assets/cp/jbc/sc/07-b.jpg') },
        { name: '大葱鸡蛋', thumb: require('../../assets/cp/jbc/sc/05.jpg'), preview: require('../../assets/cp/jbc/sc/05-b.jpg') },
      ]
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.dish-showcase {
  max-width: 80%;
  margin: 30px auto;
  padding: 0 20px;
  display: flex;
  gap: 30px;
}

/* 侧边菜单 */
.sidebar {
  width: 220px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  height: fit-content;
}
.sidebar-title {
  background: linear-gradient(135deg, #f97316, #facc15);
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  padding: 16px 0;
  letter-spacing: 2px;
}
.category-list {
  list-style: none;
  padding: 12px 0;
}
.category-list li {
  margin: 0;
}
.category-list a {
  display: block;
  padding: 12px 24px;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  color: #4a5568;
  transition: all 0.2s;
  border-left: 3px solid transparent;
}
.category-list a:hover {
  background: #fef3e2;
  color: #f97316;
  border-left-color: #f97316;
  padding-left: 28px;
}
.category-list a.active {
  background: #fef3e2;
  color: #f97316;
  border-left-color: #f97316;
  font-weight: 600;
}

/* 菜品网格 */
.dish-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 24px;
}
.dish-card {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 12px 24px -10px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s, box-shadow 0.25s;
}
.dish-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 28px -12px rgba(0, 0, 0, 0.15);
}
.dish-card:hover .dish-info {
  background: #b03e45;
}
.dish-card:hover .dish-info .dish-name {
  color:#fff;
}
.dish-img {
  width: 100%;
  height: 200px;
  display: block;
  background: #f0f0f0;
}
.dish-img /deep/ img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s;
}
.dish-card:hover .dish-img /deep/ img {
  transform: scale(1.03);
}
.dish-info {
  padding: 14px 16px 18px;
  text-align: center;
  background: #fff;
}
.dish-name {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  letter-spacing: 1px;
}
.error-slot {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #cbd5e0;
}

</style>